import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { DPAccount } from './dp-account';
import { DPAccountService } from './dp-accounts.service';
import { DPProject } from './model/dp-project';
import { DPProjectService } from './dp-project.service';
import { DPMarket } from './model/dp-market';
import { Router } from '@angular/router';
import { NotificationsService, SimpleNotificationsComponent } from 'angular2-notifications';
import { DPTimeSheet } from './model/dp-timesheet';
import { UserService } from '../user/user.service';
import { User } from '../user/user';
import { ToasterService } from 'angular2-toaster/src/toaster.service';



@Component({
    templateUrl: 'dp-project-detail.component.html'
})
export class DPProjectDetailComponent implements OnInit {
    @Input() project: DPProject;
    @Output() close = new EventEmitter();
    errorResponse: any;
    timesheets: any[];
    navigated = true; // true if navigated here
    success: any;
    storedStatus: string;
    isFirst: any;
    account: DPAccount;
    requestedProjectId: number;
    requestedAccountId: number;
    notificationTitle: any;
    notificationContent: any;
    notificationType: any;
    submitting = false;
    statuses = ['active', 'cancelled', 'completed', 'onhold'];
    projectPage = 0;
    estimatedHours: number;
    currentSpentHours = 0;
    currentBillableHours = 0;
    users: User[];
    notes: string;
    isSponsoredFirst = true;
    storedSponsered: number;


    constructor(
        private toasterService: ToasterService,

        private router: Router,
        private _service: NotificationsService,
        private accountService: DPAccountService,
        private projectService: DPProjectService,
        private route: ActivatedRoute,
        private userService: UserService, ) {
    }

    public options = {
        timeOut: 5000,
        lastOnBottom: true,
        clickToClose: true,
        maxLength: 0,
        maxStack: 7,
        showProgressBar: true,
        pauseOnHover: true,
        preventDuplicates: false,
        preventLastDuplicates: 'visible',
        rtl: false,
        animate: 'scale',
        position: ['right', 'bottom']
    };

    errorHandler(error: any) {
        this.submitting = false;
        this.notificationType = 'error';
        this.notificationTitle = 'Error';
        const jsonErrorBody = JSON.parse(error._body);
        this.notificationContent = jsonErrorBody.error.message;
        this.createNotification();
    }

    createNotification() {
        switch (this.notificationType) {
            case 'success':
                //this._service.success(this.notificationTitle, this.notificationContent);
                this.toasterService.pop('success', this.notificationTitle, this.notificationContent);
                break;
            case 'error':
                this.toasterService.pop('error', this.notificationTitle, this.notificationContent);
                //this._service.error(this.notificationTitle, this.notificationContent);
                break;
            case 'info':
                this.toasterService.pop('info', this.notificationTitle, this.notificationContent);
                //this._service.info(this.notificationTitle, this.notificationContent);
                break;
        }
    }

    ngOnInit() {
        this.route.params.forEach((params: Params) => {
            const project_id = params['project_id'];

            this.requestedProjectId = project_id;
            this.navigated = true;
            this.projectService.getProject(this.requestedProjectId)
                .then(project => {
                    this.project = project;
                    this.timesheets = this.project.project_time_sheets;
                    this.timesheets.sort((a, b) => new Date(b.added_date).getTime() - new Date(a.added_date).getTime());
                    this.calculateHours(this.timesheets);
                    this.getUserNamesForTimeSheets();
                    this.accountService.getAccount(project.account_id).then(account => { this.account = account; });
                    this.storedStatus = project.status;
                    this.storedSponsered = project.sponsored;
                    localStorage.setItem('accountId', project.account_id);

                });
            this.userService.getUsers()
                .then(res => {
                    this.users = res.user;
                    this.getUserNamesForTimeSheets();
                });
        });
        this.isFirst = true;
    }

    getUserNamesForTimeSheets() {
        if (this.timesheets) {
            // console.log('timesheet', this.timesheets);
        }
        if (this.users) {
            console.log('users', this.users);
        }
        if (this.timesheets && this.users) {
            this.timesheets.forEach(timesheet => {
                const timesheetUser = this.users.find(user => user.user_id == timesheet.user_id);
                if (timesheetUser) {
                    timesheet.user_name = timesheetUser.first_name + ' ' + timesheetUser.last_name;
                }
            });
        }
    }

    calculateHours(timesheets: DPTimeSheet[]) {
        timesheets.forEach(timesheet => this.currentSpentHours += +timesheet.hours);
        timesheets.forEach(timesheet => timesheet.billable == 1 ? this.currentBillableHours += +timesheet.hours : null);
    }

    save1(project: DPProject, isValid: boolean) {
        // call API to save customer
        if (isValid == true) {
            if (+project.estimated_hours > 999.99 || +project.estimated_hours < 0) {
                this.submitting = false;
                this.notificationType = 'error';
                this.notificationTitle = 'Error';
                this.notificationContent = 'The hours must be below 999.99 and above 0';
                this.createNotification();
            } else {
                this.submitting = true;
                if (project.estimated_end_date == '') {
                    project.estimated_end_date = null;
                } if (project.delivered_date == '') {
                    project.estimated_end_date;
                } if (project.start_date == '') {
                    project.start_date = null;
                }
                project.project_id = this.project.project_id;
                project.status = this.storedStatus;
                project.feedback = this.notes;
                project.sponsored = this.storedSponsered;
              //  console.log(this.storedSponsered);
                this.save(project);
            }
        }
    }

    save(project: DPProject) {
        this.project = project;
        this.projectService
            .updateProject(this.project)
            .then(project => {
                this.project = project;
                this.submitting = false;
                this.goBack();
            })
            .catch(error => this.errorHandler(error));

    }
    goBack() {
        if (this.navigated) {
            event.stopPropagation();
            this.router.navigate(['/demandportal/customer/account/projects', this.account.account_id]);
        }
    }
    checkStatus(status: string) {
        this.storedStatus = status;
    }

    checkExistingStatus(status: string) {
        if (this.storedStatus == status) {
            return true;
        } else {
            return false;
        }
    }

    selectProject() {
        this.projectPage = 0;
    }
    selectTimeSheet() {
        this.projectPage = 1;
    }

    selectCreateTimeSheet() {
        this.router.navigate(['/demandportal/customer/account/projects/timesheetcreate', this.project.project_id]);
    }

    gotoTimeSheetDetail(timesheet_id: number) {
        this.router.navigate(['/demandportal/customer/account/projects/timesheetdetail', timesheet_id]);
    }
    writeFeedback(insertedNotes: string) {
        this.notes = insertedNotes;
    }

    checkExistingSonsored() {
        if (this.project.sponsored == 1) {
            return true;
        }
        return false;
    }

    checkSponsored() {
        if (this.isSponsoredFirst == true) {
            this.storedSponsered = this.project.sponsored;
            this.isSponsoredFirst = false;
        }

        if (this.storedSponsered == 0) {
            this.storedSponsered = 1;
        }
        else {
            this.storedSponsered = 0;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/portalv1/dp-project-detail.component.ts